import FormContainer from "@app/components/forms/container/FormContainer";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import {CommonModal} from "@app/components/modals/CommonModal"
import {
  SharePostingSchema,
  ShareProperties,
} from "@app/components/modals/ShareModal/sharePostingSchema";
import {
  createModalComponent,
  ModalContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogClose,
  Button,
  ModalProps, useModal,
} from "@shortsworks/ui"
import { useGetAccountAccessKey } from "@shortsworks/user-api";
import { LoaderCircle } from "lucide-react";
import {useState, useEffect} from "react"

interface SharePostingContentProps {
  storyId: string;
}
const SharePostingContent = ({
  storyId,
}: ModalProps<SharePostingContentProps>) => {
  const { showModal } = useModal();
  const { data: accessKeyData, isSuccess: isSuccessGetAccessKey } =
    useGetAccountAccessKey();
  const { schemas, form, formValues, watchForm } = useFormWithSchema<ShareProperties>({
    formSchemas: SharePostingSchema,
    mode: "onChange",
  });

  const handleClickCopyScript = () => {
    return showModal(CommonModal, {title: "복사 완료", description: "스크립트가 복사되었습니다."});
  }

  // 퍼가기 모달 사이즈 체크 필요
  return (
    <ModalContent>
      <DialogHeader>
        <DialogTitle>퍼가기</DialogTitle>
      </DialogHeader>
      <div className="flex flex-row items-center gap-2 justify-between">
        {/* 위젯 또는 아이프레임 보이는 영역 모바일에서 세로로 보일 수 있음 */}
          {!isSuccessGetAccessKey && (
            <LoaderCircle className="w-6 h-6 mr-2 animate-spin" />
          )}
          <div className="w-72">
            {
              // posting title 은 심볼에서 사용되는 속성
              isSuccessGetAccessKey && (
              <shorts-works
                shape="embed"
                key={btoa(JSON.stringify(formValues))}
                access-key={accessKeyData.data.accessKey}
                posting-id={storyId}
                hide-player-controller={formValues.hidePlayerController}
                hide-like={!formValues?.showLike}
                hide-product-tag={formValues.hideProductTag}
                hide-title={!formValues.showPostingTitle}
                hide-share={!formValues.useSharedLink}
              />
            )}
          </div>
        <div className="flex flex-col gap-4">
          <FormContainer className="w-full" schemas={schemas} form={form} />
          {/* 데이터 넣는 방식은 settings로 적용되도록 관리 */}
          <textarea></textarea>
        </div>

      </div>
      <DialogFooter>
        <DialogClose asChild></DialogClose>
        <Button onClick={handleClickCopyScript} className="p-0 w-24 h-10">복사하기</Button>
      </DialogFooter>
    </ModalContent>
  );
};

export const SharePostingModal = createModalComponent(SharePostingContent);
